'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function concat(arrays, length) {
  if (!length) {
    length = arrays.reduce(function (acc, curr) {
      return acc + curr.length;
    }, 0);
  }

  var output = new Uint8Array(length);
  var offset = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = arrays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var arr = _step.value;
      output.set(arr, offset);
      offset += arr.length;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return output;
}

exports.concat = concat;